import { useValidationsField } from '@insurance/hooks'
import { InputParsedNumber } from '@shared/components'
import { Form, InputNumberProps } from 'antd'
import { useTranslation } from 'react-i18next'

import { formProps } from './utils'

export const CoefficientInput = (props: InputNumberProps) => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const { coefficientMinKey, coefficientMaxKey, coefficientProps } =
    formProps(t)

  const coefficientMin = Form.useWatch(coefficientMinKey.name, {
    preserve: true
  })
  const coefficientMax = Form.useWatch(coefficientMaxKey.name, {
    preserve: true
  })

  return (
    <Form.Item
      {...coefficientProps}
      extra={
        coefficientMin && coefficientMax
          ? t('coefficient_allowed_range', {
              min: coefficientMin,
              max: coefficientMax
            })
          : undefined
      }
      rules={[required]}
    >
      <InputParsedNumber
        className="w-full"
        placeholder={coefficientProps.label}
        min={Number(coefficientMin)}
        max={Number(coefficientMax)}
        precision={2}
        disabled={!(coefficientMin || coefficientMax)}
        {...props}
      />
    </Form.Item>
  )
}
